/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Tea_SiftingInputs */

const vi_pll_in_reason_from_tea_sifting = /** @type {(inputs: Pll_In_Reason_From_Tea_SiftingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập từ quá trình dần chè`)
};

/**

* @param {Pll_In_Reason_From_Tea_SiftingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_tea_sifting = /** @type {((inputs?: Pll_In_Reason_From_Tea_SiftingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Tea_SiftingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_tea_sifting(inputs)
});